import React from 'react';

export const AppContext = React.createContext<any>(null);

const AppContextProvider: React.FC<any> = ({ children }) => {
  return children;
};

export default AppContextProvider;
